import React from 'react';
import PropTypes from 'prop-types';
import PageResultsModal from './PageResultsModal';
import PageQuickQuoteForm from './PageQuickQuoteForm';
import { getFullUrl } from '../../utils/utils';
import { usePageQuickQuoteContext } from 'contexts/PageQuickQuoteContext';

const PageQuickQuote = ({ className, title, couponCode, buttonText, breakText, quickQuoteUrl,
  allowedOriginLocations, allowedDestinationLocations, toggleOriginDestination, buttonCustomClasses }) => {

  const { shipParams, product } = usePageQuickQuoteContext();

  const submitQuickQuote = () => {
      window?.startShipppingRudderstackEvent();
      const path = `/ship?${shipParams}&product=${product.sku}&${product.product_line.name.toLowerCase()}qty=1${couponCode ? `&coupon=${couponCode}` : ''}`
      if (quickQuoteUrl && quickQuoteUrl.length > 0) {
        window.location.href = `${quickQuoteUrl}${path}`;
      } else {
        window.location.href = getFullUrl(path, window.gon?.subdomain);
      }
  };

  return (
    <>
      <PageResultsModal
        submitQuickQuote={submitQuickQuote}
      />
      <div className={`
        ${className} w-full flex flex-col items-center justify-center text-center space-y-2
        bg-white border border-gray-300 px-4 py-6 rounded-2xl lg:max-w-[50%]
      `}>
          <div className="text-[20px] font-semibold text-[#1C2938] mb-5 md:pt-3 lg:px-4">
            {title ? title : (<div>Simplify travel. <br /> Let us lighten the load.</div>)}
          </div>

          <PageQuickQuoteForm
            allowedOriginLocations={allowedOriginLocations}
            allowedDestinationLocations={allowedDestinationLocations}
            toggleOriginDestination={toggleOriginDestination}
            buttonText={buttonText}
            breakText={breakText}
            buttonCustomClasses={buttonCustomClasses}
          />
      </div>
    </>
  );
}

PageQuickQuote.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  couponCode: PropTypes.string,
  buttonText: PropTypes.string,
  breakText: PropTypes.string,
  quickQuoteUrl: PropTypes.string,
  allowedOriginLocations: PropTypes.array,
  allowedDestinationLocations: PropTypes.array,
  toggleOriginDestination: PropTypes.bool,
  buttonCustomClasses: PropTypes.string
};

export default PageQuickQuote;
